import { ChatLayout } from './layout/ChatLayout';

function App() {
  return <ChatLayout />;
}

export default App;
